"use strict";

define('uikit/collections/tabs',['require','exports','module','underscore','marionette','../channel','../templates','./container','../modules/menu','semantic/modules/accordion'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var channel = require('../channel');
  var Templates = require('../templates');
  var ContainerView = require('./container');
  var Menu = require('../modules/menu');
  require('semantic/modules/accordion');
  var Tab = ContainerView.extend({
    className: 'ui tab',
    attributes: {
      role: 'tabpanel',
      tabindex: '0'
    },
    template: function template() {
      return '<ui name="content"></ui>';
    },
    options: {
      active: false,
      attached: 'bottom',
      fitted: false,
      basic: false,
      loading: false,
      menuItem: null,
      segment: true
    },
    update: {
      active: false,
      loading: false,
      segment: false,
      basic: false,
      fitted: false
    },
    initialize: function initialize() {
      ContainerView.prototype.initialize.apply(this, arguments);
      this.listenTo(this.menuItem, 'press', function () {
        this.triggerMethod('activated', this);
      });
    },
    updateAttributes: function updateAttributes() {
      this.menuItem.active = this.getBoolOption('active');
      this.menuItem.updateElementAttributes({
        'aria-selected': String(this.getBoolOption('active'))
      });
      this.addClass('active', this.getBoolOption('active')).addClass(this.getOption('attached') + ' attached', this.getBoolOption('attached')).addClass('loading', this.getBoolOption('loading')).addClass('segment', this.getBoolOption('segment')).addClass('basic', this.getBoolOption('basic')).addClass('fitted', this.getBoolOption('fitted'));
    }
  });
  var Tabs = ContainerView.extend({
    className: '',
    template: function template() {
      return '<ui name="menu"></ui>';
    },
    ui: {
      contents: '.content'
    },
    options: {
      openTabIndex: 0,
      visible: true,
      attached: 'top',
      tabListAriaLabel: null,
      tabListAriaLabelledBy: null,
      tabListAriaDescribedBy: null
    },
    events: {
      'keydown .menu-container > .item': 'handleTabKeydown'
    },
    update: {
      openTabIndex: false,
      visible: false
    },
    initialize: function initialize() {
      ContainerView.prototype.initialize.apply(this, arguments);
      if (!this.menu) {
        this.menu = new Menu({
          role: 'tablist',
          tabular: true,
          attached: this.attached
        });
      }
      this.on('menu:childview:change:active', function (parentView, menuItemView, menuItemView2, newValue, oldValue) {
        var tabIndexValue = newValue ? '0' : '-1';
        menuItemView.updateElementAttributes({
          tabindex: tabIndexValue
        });
      });
    },
    getMenuItemViews: function getMenuItemViews() {
      var views = _.map(this.menu._views, function (menuItemViewConfig) {
        return menuItemViewConfig.view;
      });
      return _.filter(views, function (view) {
        return view.visible;
      });
    },
    getMenuItemDOMElements: function getMenuItemDOMElements() {
      return _.map(this.getMenuItemViews(), function (menuItemView) {
        return menuItemView.el;
      });
    },
    getMenuItemViewByIndex: function getMenuItemViewByIndex(itemIndex) {
      return this.getMenuItemViews()[itemIndex];
    },
    handleTabKeydown: function handleTabKeydown(ev) {
      var menuItemViews = this.getMenuItemViews();
      var menuItemDOMElements = this.getMenuItemDOMElements();
      var currentIndex = menuItemDOMElements.indexOf(ev.target);
      var currentItemView = menuItemViews[currentIndex];
      switch (ev.keyCode) {
        case 32:
          ev.preventDefault();
          ev.stopImmediatePropagation();
          if (!currentItemView.active) {
            currentItemView.active = true;
            this.openTabIndex = currentIndex;
          }
          break;
        case 35:
          ev.preventDefault();
          this.getMenuItemViewByIndex(menuItemViews.length - 1).$el.focus();
          break;
        case 36:
          ev.preventDefault();
          this.getMenuItemViewByIndex(0).$el.focus();
          break;
        case 37:
          var itemIndex = currentIndex > 0 ? currentIndex - 1 : menuItemViews.length - 1;
          this.getMenuItemViewByIndex(itemIndex).$el.focus();
          break;
        case 39:
          var itemIndex = currentIndex < menuItemViews.length - 1 ? currentIndex + 1 : 0;
          this.getMenuItemViewByIndex(itemIndex).$el.focus();
          break;
        default:
          break;
      }
    },
    onMenuRender: function onMenuRender() {
      this.applyTablistAriaLabelling(this.menu);
    },
    applyTablistAriaLabelling: function applyTablistAriaLabelling(menu) {
      var attrs = {};
      if (this.getBoolOption('tabListAriaLabel')) {
        attrs['aria-label'] = this.getOption('tabListAriaLabel');
      }
      if (this.getBoolOption('tabListAriaLabelledBy')) {
        attrs['aria-labelledby'] = this.getOption('tabListAriaLabelledBy');
      }
      if (this.getBoolOption('tabListAriaDescribedBy')) {
        attrs['aria-describedby'] = this.getOption('tabListAriaDescribedBy');
      }
      if (!_.isEmpty(attrs)) {
        menu.ui.menuBar.attr(attrs);
      }
    },
    onChangeAttached: function onChangeAttached() {
      this.menu.attached = this.attached;
    },
    onFirstRender: function onFirstRender() {
      this.listenTo(this.vent, "change:openTabIndex", this.onOpenTabIndexChange);
    },
    add: function add(tabItemView, contentView, fn) {
      var tabContentView = null;
      if (_.isString(tabItemView)) {
        tabItemView = new Menu.Item({
          text: tabItemView,
          link: true,
          role: 'tab',
          attributes: {
            tabindex: '0'
          }
        });
      }
      this.menu.add(tabItemView);
      tabContentView = new Tab({
        content: contentView,
        menuItem: tabItemView
      });
      tabItemView.updateElementAttributes({
        'aria-controls': tabContentView.el.id
      });
      tabContentView.updateElementAttributes({
        'aria-labelledby': tabItemView.el.id
      });
      if (_.isFunction(fn)) {
        fn.call(this, tabContentView);
      }
      this.listenTo(tabContentView, 'activated', function (view) {
        this.openTabIndex = this.indexOf(view);
      });
      return ContainerView.prototype.add.call(this, tabContentView);
    },
    onOpenTabIndexChange: function onOpenTabIndexChange(self, newValue, oldValue) {
      this._activateTab(newValue, parseInt(oldValue));
    },
    _activateTab: function _activateTab(newIndex, previousIndex) {
      if (_.isNumber(previousIndex) && this.at(previousIndex)) {
        this.at(previousIndex).active = false;
      }
      if (this.at(newIndex)) {
        this.at(newIndex).active = true;
      }
    },
    open: function open(index) {
      this.openTabIndex = index;
      return this;
    },
    onRender: function onRender() {
      this.$el.prepend(this.menu.$el);
      this.menu.render();
    },
    onAfterRenderAll: function onAfterRenderAll() {
      this._activateTab(this.openTabIndex);
    },
    onRemove: function onRemove(view) {
      this.menu.remove(view);
    },
    onBeforeDestroy: function onBeforeDestroy() {
      if (this.menu) {
        this.menu.destroy();
      }
    }
  });
  Tabs.Tab = Tab;
  channel.reply('tabs', function () {
    return Tabs;
  });
  module.exports = Tabs;
});

